<template>
  <LayoutGradient :title="pageTitle" icon="fa-file-signature">
    <template v-slot:headerRight>
      <b-btn variant="outline-info" @click="$router.back()">
        <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
      </b-btn>
    </template>
    <b-card class="m-3 mt-n10">
      <b-form @submit="onSubmit">
        <b-form-group :label="$t('protocol.form.fields.nome.label')" label-for="input-name">
          <b-form-input id="input-name" v-model="protocol.name" type="text"/>
        </b-form-group>
        <b-form-group
            :label="$t('protocol.form.fields.classe.label')"
            label-for="input-classe"
            :description="$t('protocol.form.fields.classe.description')"
        >
          <b-form-input id="input-classe" v-model="protocol.class" type="text"/>
        </b-form-group>
        <b-form-group
            label-for="input-status"
            :label="$t('protocol.form.fields.has_protocol_settings.label')"
            :description="$t('protocol.form.fields.has_protocol_settings.description')"
        >
          <b-form-checkbox id="has_protocol_settings" v-model="hasProtocolSettings" size="lg" switch/>
          <b-form-group
              v-if="hasProtocolSettings"
              label-for="input_protocol_settings"
              :label="$t('protocol.form.fields.protocol_settings.label')"
              :description="$t('protocol.form.fields.protocol_settings.description')"
          >
            <b-form-select
                id="input_protocol_settings"
                v-model="protocol.id_vns_protocol_settings"
                :options="protocolSettings"
            />
          </b-form-group>
        </b-form-group>
        <b-form-group
            :label="$t('protocol.form.fields.status.label')"
            label-for="input-status"
            :description="$t('protocol.form.fields.status.description')"
        >
          <b-form-checkbox id="input-status" v-model="protocol.status" size="lg" switch/>
        </b-form-group>
        <b-button type="submit" variant="success">
          <i class="fas fa-save"/> {{ $t('protocol.form.fields.botao_salvar') }}
        </b-button>
      </b-form>
    </b-card>
  </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient";
import ProtocolRepository from '@/repositories/vns/ProtocolRepository'
import {mapActions, mapGetters} from "vuex";

export default {
  name: "Form",
  components: {
    LayoutGradient
  },
  data() {
    return {
      protocol_id: null,
      hasProtocolSettings: false
    }
  },
  computed: {
    ...mapGetters({
      protocolSettings: 'protocolSettings/all',
      protocol: 'protocol/current',
      isLoading: 'protocol/isLoading'
    }),
    pageTitle() {
      if (this.protocol_id) return this.$t('protocol.form.titulo_pagina.editar')
      return this.$t('protocol.form.titulo_pagina.criar')
    },
    protocolSettings() {
      if (this.store_protocolSettings && Array.isArray(this.store_protocolSettings)) {
        return this.store_protocolSettings.map((ent) => {
          return {
            text: ent.name,
            value: ent.id
          }
        })
      }
      return [];
    }
  },
  methods: {
    ...mapActions([
      'protocol/listOne',
      'protocolSettings/listAll'
    ]),
    async onSubmit(evt) {
      evt.preventDefault()
      if (this.$route.params.id) {
        this.update()
      } else {
        this.create()
      }
    },
    create() {
      ProtocolRepository.post(this.protocol).then(() => {
        this.$snotify.success(this.$t('protocol.form.create.success'))
        this.$router.push({name: 'vns.protocol'})
      }).catch(error => {
        this.$snotify.error(this.$t('protocol.form.create.error'))
        if (error.response.status === 422) {
          ProtocolRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    },
    update() {
      ProtocolRepository.put(this.protocol_id, this.protocol).then(() => {
        this.$snotify.success(this.$t('protocol.form.update.success'))
        this.$router.push({name: 'vns.protocol'})
      }).catch(error => {
        this.$snotify.error(this.$t('protocol.form.update.error'))
        if (error.response.status === 422) {
          ProtocolRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    }
  },
  async mounted() {
    this['protocolSettings/listAll'](0)
    this.$store.commit('protocol/setCurrent', {status: false})
    if (this.$route.params.id) {
      this.protocol_id = this.$route.params.id
      await this['protocol/listOne'](this.$route.params.id)
      if (this.protocol.id_vns_protocol_settings) {
        this.hasProtocolSettings = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
